import {
  CHARTS_BLUE,
  CHARTS_GREEN,
  CHARTS_ORANGE,
  CHARTS_PURPLE,
  CHARTS_YELLOW
} from '@/config/colors';

export type Color = { name: string; hex: string };

export const vibrantPalette: Color[] = [
  { name: 'Blue', hex: CHARTS_BLUE },
  { name: 'Green', hex: CHARTS_GREEN },
  { name: 'Yellow', hex: CHARTS_YELLOW },
  { name: 'Purple', hex: CHARTS_PURPLE },
  { name: 'Orange', hex: CHARTS_ORANGE },
  { name: 'Pink', hex: '#FF2D55' }
];

export const monoBluePalette: Color[] = [
  { name: 'Light sky', hex: '#BDDEFF' },
  { name: 'Sky blue', hex: '#85C1F5' },
  { name: 'Ocean blue', hex: '#5BA7F7' },
  { name: 'Royal blue', hex: '#378CE4' },
  { name: 'Deep blue', hex: '#1976D2' },
  { name: 'Navy blue', hex: '#0D47A1' }
];

export const balancedPalette: Color[] = [
  { name: 'Dusty blue', hex: '#8BB6C7' },
  { name: 'Sage green', hex: '#A8C09A' },
  { name: 'Warm beige', hex: '#D4B483' },
  { name: 'Lavender', hex: '#C4A5C7' },
  { name: 'Dusty rose', hex: '#D19B9B' },
  { name: 'Cool gray', hex: '#9EAAB0' }
];

export enum ColorPalette {
  Vibrant = 'Vibrant',
  Monochrome = 'Monochrome',
  Balanced = 'Balanced'
}
